@if (notification) {
  <div class="drawer-content-row">
    <div class="frame24pxspacer"></div>
    <div class="drawer-content-notification-container">
      <div class="drawer-content-notification" [ngStyle]="{'background-color':color}">
        @if (icon) {
          <div class="drawer-content-colicon">
            <img loading="lazy" [src]="imageURL|async" class="drawer-content-iconcheckmark"/>
          </div>
        }
        <div class="drawer-content-coldescription flex-column flex-md-row">
          <span class="drawer-content-notification-text" [ngStyle]="{'color':textColor}">
            @if (header) { <div class="drawer-content-notification-text labelmediummedium">{{header}}</div> }
            <div class="drawer-content-notification-text paragraphsmall">{{text}}</div>
          </span>
          @if (isActionable) {
            <span class="drawer-content-notification-action">
              <button type="button" class="btn btn-primary" (click)="action()">{{actionText}}</button>
            </span>
          }
        </div>
      </div>
    </div>
  </div>
}
